import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 8D47ED6A-831A-49F2-8E43-67F16F8351E6
 * name shield-cross
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-cross.svg
 * tags
 * - Gaming / RPG 
 * - Religion 
 */
export const ShieldCrossIcon = createSvgIcon(<><path d="M12,1L3,5V11C3,16.5 6.8,21.7 12,23C17.2,21.7 21,16.5 21,11V5L12,1M16,10H13V18H11V10H8V8H11V5H13V8H16V10Z" /></>, 'ShieldCrossIcon');
export default ShieldCrossIcon